<template>
  <div class="container diy-page">
    
    <v-head></v-head>
    <v-left current="email"></v-left>

    <div style="background:rgb(251,251,251)">
      <div style="position:relative;">
        <email-left :is_index_page="false" ref="email_left_ref" @get_messages_from_left="get_messages_from_left"></email-left>
        
        <div style="margin-left:314px; min-height:555px; background:white;">
          
          <div style="padding: 15px 20px; border-bottom: 1px solid #f0f0f0;">
            <el-button size="mini" type="primary" plain @click="handle_mark_unread">Mark Unread</el-button>
            <el-button size="mini" plain>Tag</el-button>
          </div>

          <div v-loading="loading" style="min-height:200px; width:100%;">
            <ul v-if="detail && detail.record && detail.record.length > 0">
              <li v-for="(msg, index) in detail.record" :key="index" class="st-email-de-li">
                
                <a :class="['user-port-cirs', msg.is_me ? 'me' : 'buyer']">
                  {{ msg.is_me ? 'M' : 'U' }}
                </a>
                
                <div style="margin-left:55px; position:relative;">
                  <h3>{{ msg.from_address }}</h3>
                  
                  <div style="margin-top:10px;">
                    <p class="pointer email-subject-bar" @click="toggle_email_collapse(msg, index)">
                      <span class="subject-text">{{ msg.subject || '(No Subject)' }}</span>
                      <i :class="[msg.is_show_html ? 'el-icon-caret-top' : 'el-icon-caret-bottom']"></i>
                    </p>
                    
                    <div v-show="msg.is_show_html" class="email-iframe-wrapper" style="margin-top: 12px;">
                      <iframe
                        :id="'email-frame-' + index"
                        :srcdoc="cleanAndFormatEmail(msg.body_content)"
                        frameborder="0"
                        width="100%"
                        scrolling="no"
                        sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
                        style="width: 100%; border: none; display: block;"
                        @load="adjust_iframe_height('email-frame-' + index)"
                      ></iframe>
                    </div>

                    <div v-if="msg.attachments && msg.attachments.length > 0" style="margin-top: 15px; padding-top: 10px; border-top: 1px dashed #eee;">
                      <span style="font-size: 12px; color: #909399; display: block; margin-bottom: 8px;">Attachments:</span>
                      <section v-for="(a, index_a) in msg.attachments" :key="index_a" style="display:inline-block; margin-right: 15px; margin-bottom: 10px; vertical-align: top;">
                        <el-image
                          v-if="a.type === 'inline_image'"
                          style="width: 60px; height: 60px; border-radius: 4px; border: 1px solid #e4e7ed;"
                          :src="a.file_oss"
                          :preview-src-list="[a.file_oss]"
                          fit="cover"
                        >
                        </el-image>
                        <el-link 
                          v-else 
                          type="primary" 
                          icon="el-icon-document" 
                          :href="a.file_oss" 
                          target="_blank"
                          style="font-size: 13px;"
                        >
                          {{ a.file_name }}
                        </el-link>
                      </section>
                    </div>
                  </div>
                  
                  <span style="position: absolute; top:0; right:0; font-size: 12px;" class="gray-color">{{ msg.sent_time }}</span>
                </div>
              </li>
            </ul>

            <div v-else-if="!loading" style="padding: 60px 0; text-align: center;">
              <el-empty description="No email interaction records found"></el-empty>
            </div>

            <div style="margin-top:20px; margin-bottom:100px; padding:20px; box-sizing:border-box;" v-if="detail">
              <Sender 
                :email_detail_id="id" 
                :account="detail.account"
                email_message_type="0"></Sender>
            </div>
          </div>
        </div>
      </div>
      <component :is="activeName"></component>
    </div>
  </div>
</template>

<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
import email_left from "@/pages/email/_left";
import Sender from "@/pages/email/_sender";

export default {
  components: {
    "v-head": head,
    "v-left": left,
    'email-left': email_left,
    Sender,
  },
  computed: {
    checked_order() {
      if (!this.orders_options) return null;
      for (var i = 0; i < this.orders_options.length; i++) {
        if (this.writeForm && this.writeForm.order_no == this.orders_options[i].order_no) {
          return this.orders_options[i];
        }
      }
      return null;
    },
  },
  data() {
    return {
      uid: 0,
      id: 0,
      loading: false,
      activeName: "",
      detail: null,
      orders: null,
      isClearEditor: false,
      read_status_options: [
        {value: '', label: ''},
        {value: 'unread', label: 'Unread'},
        {value: 'read', label: 'Read'},
      ],
      templates_options: [],
      orders_options: [],
    };
  },
  methods: {
    handleClick(e) {
      // 预留卡片切换占位
    },
    change_filter_read_status() {
      if (this.filter) {
        this.filter.page = 1;
        this.get_messages();
      }
    },

    get_messages_from_left(folder_id) {
      // 树形文件夹切换拦截
    },
cleanAndFormatEmail(htmlContent) {
    if (!htmlContent) return '';

    // 补全基础邮件重置样式与媒体查询
    const injectStyle = `
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
          /* 1. 全局重置 */
          html, body {
            margin: 0 !important;
            padding: 16px !important;
            font-family: 'Inter Variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
            background-color: #ffffff !important;
            color: #303030 !important;
            box-sizing: border-box !important;
          }

          /* 2. 强行解除 470px 写死限制，使其完美居中或自适应 */
          .container, .editorContainer, table {
            max-width: 100% !important;
            margin: 0 auto !important;
          }

          /* 3. 修复 Shopify line-height: px 语法错误引起的字体重叠 */
          p, td, h3 {
            line-height: 1.5 !important;
          }

          /* 4. 图片与容器自适应 */
          img {
            max-width: 100% !important;
            height: auto !important;
          }

          /* 5. 链接颜色与行为固定 */
          a {
            color: #005BD3 !important;
          }
        </style>
        <base target="_blank">
      </head>
    `;

    // 如果源码包含 <html> 或 <body>，做无缝注入
    if (htmlContent.includes('<html>')) {
      return htmlContent.replace('<html>', '<html>' + injectStyle);
    }
    return '<html>' + injectStyle + '<body>' + htmlContent + '</body></html>';
  },
// 注入基础防护样式与 <base> 标签
  format_email_content(content) {
    if (!content) return '';

    // 防护样式：强行重置 iframe Body 的默认边距，并确保图片/表格自适应
    const injectStyle = `
      <style>
        html, body {
          margin: 0 !important;
          padding: 0 !important;
          width: 100% !important;
          word-break: break-word;
          overflow-x: hidden !important;
        }
        img {
          max-width: 100% !important;
          height: auto !important;
        }
        table {
          max-width: 100% !important;
        }
      </style>
      <!-- 确保邮件里的相对路径链接在在新标签页打开，且不破坏当前页 -->
      <base target="_blank">
    `;

    // 如果邮件源码包含 <head>，注入到 <head> 中；否则直接拼接在开头
    if (content.includes('<head>')) {
      return content.replace('<head>', '<head>' + injectStyle);
    }
    return injectStyle + content;
  },

  // 高度自适应函数（配合 allow-same-origin 使用）
  adjust_iframe_height(iframeId) {
    const iframe = document.getElementById(iframeId);
    if (iframe && iframe.contentWindow) {
      try {
        // 动态获取邮件内容的真实高度并赋值给 iframe
        const body = iframe.contentWindow.document.body;
        const html = iframe.contentWindow.document.documentElement;
        const height = Math.max(
          body.scrollHeight, body.offsetHeight,
          html.clientHeight, html.scrollHeight, html.offsetHeight
        );
        iframe.style.height = height + 'px';
      } catch (e) {
        console.warn('无法计算 iframe 高度:', e);
      }
    }
  },

    /**
     * 折叠切换控制器（联动计算高度）
     */
    toggle_email_collapse(msg, index) {
      msg.is_show_html = !msg.is_show_html;
      if (msg.is_show_html) {
        setTimeout(() => {
          this.adjust_iframe_height('email-frame-' + index);
        }, 80);
      }
    },

    /**
     * 手动触发标记为未读
     */
    handle_mark_unread() {
      if (!this.detail || !this.detail.id) return;
      this.loading = true;
      this.$http
        .post("/v1/pri/store-email/mark-unread", {
          mailbox_email: this.detail.account.mailbox_email,
          email_id: this.detail.message.email_id,
        })
        .then((response) => {
          this.loading = false;
          const res = response.data;
          if (res.code === 1) {
            this.$message.success("Successfully marked as unread");
            if (this.detail.label_ids && this.detail.label_ids.indexOf("UNREAD") === -1) {
              this.detail.label_ids.push("UNREAD");
            }
          }
        }).catch(() => { this.loading = false; });
    },

    /**
     * 进入详情时自动反向发送已读状态回执
     */
    handle_mark_read() {
      if (!this.detail || !this.detail.message || this.detail.message.label_ids.indexOf("UNREAD") === -1) {
        return;
      }
      this.$http
        .post("/v1/pri/store-email/mark-read", {
          mailbox_email: this.detail.account.mailbox_email,
          email_id: this.detail.message.email_id,
        })
        .then((response) => {
          const res = response.data;
          if (res.code === 1) {
          }
        }).catch((err) => {
          console.error("Failed to update status: ", err);
        });
    },

    /**
     * 请求消息详情流
     */
    get_detail() {
      this.loading = true;
      this.$http
        .post("/v1/pri/store-email/messages-detail", { id: this.id })
        .then((response) => {
          this.loading = false;
          const res = response.data;
          if (res.code === 1 && res.data) {
            const data = res.data;
            
            // 响应式注入状态：默认折叠全部历史，唯独将最后一条（最新的一封）展开呈现
            if (data.record && data.record.length > 0) {
              data.record.forEach((item, index) => {
                this.$set(item, 'is_show_html', index === data.record.length - 1);
              });
            }
            this.detail = data;
            
            // 联动标记
            this.handle_mark_read();
          }
        }).catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },
  },
  mounted() {
    var admin_password = this.getCookie("admin_password");
    if (admin_password === 'b1315E8') {
      this.uid = parseInt(localStorage.getItem("uid"));
    }
    if (this.uid !== 1 && this.uid !== 10000 && this.uid !== 10001) { 
      return;
    }
    this.id = this.getUrlParam("id");
    if (this.id) {
      this.get_detail();
    }

    this.$store.dispatch("get_email_folders", {
      callback: (e) => {
 
    }});


  }
};
</script>

<style scoped>
/* 开启 scoped 全面阻断对外样式的溢出与冲突 */
.user-port-cirs {
  display: block;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  position: absolute;
  left: 20px;
  top: 20px;
  font-weight: bold;
}
.user-port-cirs.me {
  border: 1px solid #fbc4c4;
  background: #fef0f0;
  color: #f56c6c;
}
.user-port-cirs.buyer {
  border: 1px solid #dcdfe6;
  background: #f4f4f5;
  color: #909399;
}
.st-email-de-li {
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  position: relative;
}
.email-subject-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8f9fa;
  padding: 10px 14px;
  border-radius: 4px;
  transition: background 0.2s ease;
}
.email-subject-bar:hover {
  background: #f0f2f5;
}
.subject-text {
  font-weight: 500;
  font-size: 13px;
  color: #4a4a4a;
}
.email-iframe-wrapper {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}
.email-iframe-wrapper iframe {
  display: block;
  will-change: height;
  transition: height 0.15s ease-in-out;
}
</style>


// WEBPACK FOOTER //
// src/pages/email/Detail.vue